import String from 'string';
import _      from 'lodash';

import { setViewList, LIST_VIEW, setViewMap } from './ViewAction';

export const INIT_FILTERS     = 'INIT_FILTERS';
export const SELECT_FILTER    = 'SELECT_FILTER';
export const FILTER_PLACES    = 'FILTER_PLACES';
export const UPDATE_FILTER    = 'UPDATE_FILTER';

export const FILTER_ALL        = 'all';
export const FILTER_POPULAR    = 'popular';
export const FILTER_TRAILS     = 'trails';
export const FILTER_FAVOURITES = 'favourites';
export const FILTER_LATEST     = 'latest';

let filters = {};

filters[FILTER_ALL] = {
    id    : FILTER_ALL,
    name  : 'All',
    empty : 'We could not find any places.',
    places: []
};

filters[FILTER_POPULAR] = {
    id    : FILTER_POPULAR,
    name  : 'Most Popular',
    empty : 'We could not find any places.',
    places: []
};

filters[FILTER_FAVOURITES] = {
    id    : FILTER_FAVOURITES,
    name  : 'Favourites',
    empty : 'You have not added any favourite places.',
    places: []
};

filters[FILTER_TRAILS] = {
    id    : FILTER_TRAILS,
    name  : 'Trails',
    empty : 'We could not find any trails.',
    places: []
};

filters[FILTER_LATEST] = {
    id    : FILTER_LATEST,
    name  : 'Latest',
    empty : 'We could not find any places.',
    places: []
};

export const receiveFilters = (categories, tags) =>
{
    return (dispatch) =>
    {
        let usableFilters = {};

        categories.map((filter) =>
        {
            if (typeof filters[filter.key] !== 'undefined')
            {
                usableFilters[filter.key] = {
                    id    : filter.id,
                    empty : filter.emptyText,
                    name  : filter.name,
                    places: [],
                    tag: false,
                };
            }

            return null;
        });

        tags.map((tag) =>
        {
            let name               = String(tag.tag).titleCase().s;
            usableFilters[tag.tag] = {
                id    : tag.tag,
                name  : name,
                empty : 'We could not find any places tagged with ' + name + '.',
                places: [],
                tag: true,
            };

            return null;
        });

        dispatch({
            type   : INIT_FILTERS,
            filters: usableFilters,
            tags   : tags
        })
    }
};

export const hydrateFilter = (filter, places) => {
    let hydrated = [];

    if (null !== filter && null !== filter.places)
    {
        hydrated = filter.places.map((placeId) =>
        {
            let index = _.findIndex(places, (elem) => { return elem.id === placeId });
            return places[index];
        });
    }

    return hydrated;
};

const filterAll = (places) => {
    return _.map(places, 'id');
};

//---------------------------------------------------------------------------------------------------------------

const filterFavourites = (places, user) =>
{
    let filtered =  _.filter(places, (place) =>
    {
        return user.favourites.includes(place.id);
    });

    return _.map(filtered, 'id');
};

//---------------------------------------------------------------------------------------------------------------

const filterPopular = (places) => {
    let ordered  = _.orderBy(places, 'popularity', 'desc');
    let filtered = _.slice(ordered, 0, 6);
    return _.map(filtered, 'id');
};

//---------------------------------------------------------------------------------------------------------------

const filterLatest = (places) =>
{
    let ordered  = _.orderBy(places, 'created', 'desc');
    let filtered = _.slice(ordered, 0, 6);
    return _.map(filtered, 'id');
};

//---------------------------------------------------------------------------------------------------------------

const filterTrails = (places) => {
    let filtered = _.filter(places, (o) => {
        return o.type === 'trail' && o.visible === true;
    });

    return _.map(filtered, 'id');
};

//---------------------------------------------------------------------------------------------------------------

const filterTag = (places, tag) => {
    let filtered = _.filter(places, (o) => { return _.indexOf(o.tags, tag) > -1 });
    return _.map(filtered, 'id');
};

//---------------------------------------------------------------------------------------------------------------

export const selectFilter = (filter) => {
    return {
        type    : SELECT_FILTER,
        selected: filter
    }
};

//---------------------------------------------------------------------------------------------------------------

export const setFilter = (filter) => {
    return (dispatch, getState) => {
        let selected = getState().filter.filters[filter];
        if (FILTER_TRAILS === filter && !getState().view.userActed) {
            dispatch(setViewList(false));
        } else if (!getState().view.userActed && LIST_VIEW === getState().view.placesView) {
            dispatch(setViewMap(false));
        }
        dispatch(selectFilter(selected));
    }
};

//---------------------------------------------------------------------------------------------------------------

export const filterPlaces = (places) => {
    return (dispatch, getState) => {
        let filters                = getState().filter.filters;
        let user                   = getState().user;
        let tags                   = getState().filter.tags;

        filters[FILTER_ALL].places        = filterAll(places);

        if (typeof filters[FILTER_FAVOURITES] !== 'undefined') {
            filters[FILTER_FAVOURITES].places = filterFavourites(places, user);
        }

        if (typeof filters[FILTER_POPULAR] !== 'undefined') {
            filters[FILTER_POPULAR].places    = filterPopular(places);
        }

        if (typeof filters[FILTER_LATEST] !== 'undefined') {
            filters[FILTER_LATEST].places     = filterLatest(places);
        }

        if (typeof filters[FILTER_TRAILS] !== 'undefined') {
            filters[FILTER_TRAILS].places     = filterTrails(places);
        }

        _.forEach(tags, (tag) => {
            filters[tag.tag].places = filterTag(places, tag.tag);
        });

        dispatch({ type: FILTER_PLACES, filters: filters });
    }
};

//---------------------------------------------------------------------------------------------------------------

export const updateFavourites = (user) =>
{
    return (dispatch, getState) =>
    {
        let filters = getState().filter.filters;
        let places  = getState().places.items;
        if (typeof filters[FILTER_FAVOURITES] !== 'undefined') {
            filters[FILTER_FAVOURITES].places = filterFavourites(places, user);
        }
        dispatch({ type: UPDATE_FILTER, filters: filters });
    }
};




// WEBPACK FOOTER //
// ./src/actions/FilterAction.js